/**
 * Token CSRF da sessão Laravel lido do header de resposta X-CSRF-TOKEN.
 *
 * Pelo proxy Netskope o front e a API ficam em hosts diferentes, então o JS não lê o
 * cookie XSRF-TOKEN (preso ao host da API). A API devolve o token neste header
 * (exposto no CORS) e o front o reenvia em X-CSRF-TOKEN nas requisições seguintes.
 * Na intranet o cookie continua funcionando; o header só reforça com o mesmo token.
 */
import { resolveApiBase } from '../utils/resolveApiBase';

const CSRF_TOKEN_HEADER = 'x-csrf-token';
const API_VERSIONS = [1, 2];

let currentToken = null;

function originOf(url) {
  try {
    return new URL(url).origin;
  } catch (error) {
    return null;
  }
}

/** Compara origin (protocolo + host + porta): prefixo de string deixaria passar `api.dominio.evil.com`. */
function isApiRequest(url) {
  const target = String(url || '');
  if (!/^https?:\/\//i.test(target)) return true;
  const origin = originOf(target);
  return Boolean(origin) && API_VERSIONS.some((version) => origin === originOf(resolveApiBase(version)));
}

/** Token mais recente da API, para clientes fora do axios (ex.: Dropzone). */
export function getCsrfToken() {
  return currentToken;
}

/** Guarda o token mais recente enviado pela API. */
export function captureCsrfTokenFromResponse(response) {
  if (!response || !isApiRequest(response.config && response.config.url)) return;

  const token = response.headers && response.headers[CSRF_TOKEN_HEADER];
  if (token) {
    currentToken = token;
  }
}

/** Anexa o token às requisições da API, sem sobrescrever um header definido pela chamada. */
export function applyCsrfTokenToRequest(config) {
  if (!currentToken || !isApiRequest(config.url)) return config;

  config.headers = config.headers || {};
  if (!config.headers['X-CSRF-TOKEN'] && !config.headers[CSRF_TOKEN_HEADER]) {
    config.headers['X-CSRF-TOKEN'] = currentToken;
  }
  return config;
}
